/** returns Savings History List
@returns { Array }
*/
export const getHistoryList = state => state.historyList

/** returns Savings History List Has More
@returns { Array }
*/
export const getHistoryListHasMore = state => state.historyListHasMore

/** returns transfers status list
@return { Array }
*/
export const getStatusList = state => state.statusList

/** returns channels list
@return { Array }
*/
export const getChannelsList = state => state.channelsList

/** returns Operation Details
@return { Array }
*/
export const getOperationDetails = state => state.operationDetails
